































































import { Component, Prop, Mixins } from "vue-property-decorator";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

library.add(faSpinner);

import ModalBase from "@/components/modal/ModalBase.vue";
import CurrencyMixin from "@/mixins/currency.ts";

import { ACTIONS } from "@/event-bus";

@Component({
  components: {
    FontAwesomeIcon,
    ModalBase,
  },
})
export default class ModalRewards extends Mixins(CurrencyMixin) {
  @Prop(String) private type!: string;
  @Prop(String) private amount!: string;
  @Prop(Boolean) private showSpinner!: boolean;

  private tryCloseModal() {
    this.$emit(ACTIONS.CLOSE);
  }

  private claim() {
    this.$emit("claim");
  }

  private restake() {
    this.$emit("restake");
  }
}
